<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllCheckList('printCheckList')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllCheckList()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.branchId"
                :items="branchList"
                color="blue-grey lighten-2"
                label="Choose Branch..."
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                :readonly="checkUserBranch() ? true : false"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.shopId"
                :items="shopList"
                color="blue-grey lighten-2"
                label="Choose Shop..."
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                :readonly="checkUserShop() ? true : false"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.departmentId"
                :items="departmentList"
                color="blue-grey lighten-2"
                label="Choose Department..."
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.machineIds"
                :items="machineList"
                color="blue-grey lighten-2"
                label="Choose Machine..."
                menu-props="auto"
                item-text="name"
                item-value="id"
                @change="getLocationListByMachineIds"
                multiple
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.machineCheckListDetailIds"
                :items="locationList"
                color="blue-grey lighten-2"
                label="Choose Location..."
                item-text="location"
                menu-props="auto"
                item-value="id"
                multiple
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.machineTypeIds"
                :items="machineTypeList"
                color="blue-grey lighten-2"
                label="Select Machine Type"
                item-text="name"
                item-value="id"
                menu-props="auto"
                multiple
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="checkList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.machineHeaderName }}</td>
              <td>{{ props.item.location }}</td>
              <td>{{ props.item.workDescription }}</td>
              <td
                v-for="(header, index) in checkListFrequencyList"
                :key="index"
              >
                <v-icon
                  v-if="showIcon(header.id, props.item.checklistFrequencyIds)"
                  medium
                  color="green"
                  >check_circle</v-icon
                >
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>{{ props.item.checklistRemark }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all format-->
    <div
      id="printCheckList"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Check List Report</p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th
                v-for="(column, index) in headers"
                :key="index"
                :style="{ textAlign: column.align }"
              >
                {{ column.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allCheckList" :key="index">
              <td>{{ item.machineHeaderName }}</td>
              <td>{{ item.location }}</td>
              <td>{{ item.workDescription }}</td>
              <td
                v-for="(header, index) in checkListFrequencyList"
                :key="index"
              >
                <span v-if="showIcon(header.id, item.checklistFrequencyIds)"
                  >True</span
                >
                <span v-else>False</span>
              </td>
              <td>{{ item.checklistRemark }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { branchService } from "../../services/branch-service";
import { departmentService } from "../../services/department-service";
import { shopService } from "../../services/shop-service";
import { machineService } from "../../services/machine-service";
import { checkListService } from "../../services/check-list-service";
import { commonService } from "../../services/common-service";
import { machineTypeService } from "../../services/machine-type-service";

export default {
  name: "CheckList",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Asset Management",
        disabled: true,
      },
      {
        text: "Check List",
        disabled: true,
      },
    ],
    defHeaders: [
      { text: "Machine", align: "left", sortable: false },
      { text: "Location(Device Name)", align: "left", sortable: false },
      { text: "Work Description", align: "left", sortable: false },
      { text: "Remark", align: "left", sortable: false },
    ],
    headers: [
      { text: "Machine", align: "left", sortable: false },
      { text: "Location(Device Name)", align: "left", sortable: false },
      { text: "Work Description", align: "left", sortable: false },
      { text: "Remark", align: "left", sortable: false },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0,
      sortBy: "mh.name",
    },
    queryParams: {
      branchId: "",
      shopId: "",
      departmentId: "",
      machineCheckListDetailIds: [],
      machineIds: [],
      machineTypeIds: [],
    },
    totalRows: 0,
    machineList: [],
    branchList: [],
    departmentList: [],
    shopList: [],
    locationList: [],
    checkListFrequencyList: [],
    checkList: [],
    allCheckList: [],
    machineTypeList: [],
    rowsPerPageItems: [25, 50, 100],
  }),
  created() {
    //for deep linking
    if (this.$route.query.branchId) {
      this.queryParams.branchId = this.$route.query.branchId;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.departmentId) {
      this.queryParams.departmentId = this.$route.query.departmentId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }

    this.queryParams.shopId = this.checkUserShop();
    this.queryParams.branchId = this.checkUserBranch();

    this.getActiveBranchList();
    this.getActiveDepartmentList();
    this.getAllShop();
    this.getActiveMachineList();
    this.getActiveMachineTypeList();
  },
  methods: {
    checkUserShop() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "ASSET_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    checkUserBranch() {
      // if (this.user.role.roleName == "ASSET_MANAGER") {
      //   return this.user.branchId;
      // } else {
      return "";
      // }
    },
    getActiveBranchList() {
      branchService
        .getBranchByStatus("ACTIVE")
        .then((res) => {
          this.branchList = res.data;
          this.branchList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveDepartmentList() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
          this.departmentList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveMachineList() {
      machineService
        .getMachinesByStatus("ACTIVE")
        .then((res) => {
          this.machineList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveMachineTypeList() {
      machineTypeService
        .getMachineTypeByStatus("ACTIVE")
        .then((res) => {
          this.machineTypeList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "check-lists",
        query: this.queryParams,
      });
      this.changeHeader();
      this.getCheckLists();
    },
    getCheckLists() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      checkListService
        .getCheckList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.checkList = res.data.machineChecklistDetailList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getLocationListByMachineIds() {
      this.queryParams.machineCheckListDetailIds = [];
      this.locationList = [];
      if (this.queryParams.machineIds) {
        let params = { machineIds: this.queryParams.machineIds };
        machineService
          .getMachineChecklistDetailsByMachineIds(params)
          .then((res) => {
            this.locationList = res.data;
          })
          .catch((err) => {
            console.log(err);
            this.normalHeader();
          });
      }
    },
    changeHeader() {
      this.checkListFrequencyList = [];
      //set default headers
      this.normalHeader();
      //add dynamic check list frequnecy columns in default headers
      let params = {
        machineIds: this.queryParams.machineIds,
        machineCheckListDetailIds: this.queryParams.machineCheckListDetailIds,
      };
      machineService
        .getCheckListFrequenciesByMachineIds(params)
        .then((res) => {
          this.checkListFrequencyList = res.data;
          this.headers.splice(
            3,
            0,
            ...this.checkListFrequencyList.map((v) => ({
              text: v.name,
              value: v.name,
              align: "left",
              sortable: false,
            }))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    normalHeader() {
      this.headers = [];
      this.headers.push(...this.defHeaders);
    },
    showIcon(id, frequencyIdList) {
      return frequencyIdList.find((v) => v == id) ? true : false;
    },
    printAllCheckList(divName) {
      this.buttonLoading = true;
      checkListService
        .getCheckList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allCheckList = res.data.machineChecklistDetailList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
        });
      this.buttonLoading = false;
    },
    exportAllCheckList() {
      this.buttonLoading = true;
      checkListService
        .getCheckListExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>
